export const dataSlides = [
    {
    id: 1,
    image: "https://www.sephora.com/contentimages/editorial/2023/SkinDailyDeals/Desktop/banner-1-lancome-desktop.jpg?imwidth=388"
    },
    {
    id: 2,
    image: "https://www.sephora.com/contentimages/editorial/2023/SkinDailyDeals/Desktop/banner-2-shiseido-desktop.jpg?imwidth=388"
    },
    {
    id: 3,
    image: "https://www.sephora.com/contentimages/editorial/2023/SkinDailyDeals/Desktop/banner-3-sunday-riley-desktop.jpg?imwidth=388"
    },
    {
    id: 4,
    image: "https://www.sephora.com/contentimages/editorial/2023/SkinDailyDeals/Desktop/banner-4-tula-mario-desktop-update.jpg?imwidth=388"
    },
    {
    id: 5,
    image: "https://www.sephora.com/contentimages/editorial/2023/SkinDailyDeals/Desktop/banner-5-coola-josie-maran-desktop.jpg?imwidth=388"
    },
    {
    id: 6,
    image: "https://www.sephora.com/contentimages/editorial/2023/SkinDailyDeals/Desktop/banner-6-estee-lauder-desktop.jpg?imwidth=388"
    }
]